import httpService from './httpService';

import * as models from '../utils/models';
import * as constants from '../utils/constants';

import { AxiosRequestConfig } from 'axios';

interface CreateInspectionTypePayload { 
	inspectionCode: string;
	inspectionName: string;
}

export interface SplitProjectPayload {
	projectId: string;
	action: 'split' | 'duplicate';
	data: { 
		documentNumberPrefix: string;
		payload: string;
	}[];
}

function archiveProject(projectId: string) {
	return httpService.post(`/archive/${projectId}`);
}

function activateProject(projectId: string, data: models.ActivateProjectModel, onUploadProgress: models.ProgressChange) {
	const endpoint: string = '/project/review-project/' + projectId;
	return httpService.post(endpoint, data, { onUploadProgress });
}

function addProgressComment(
	projectId: string,
	data: Pick<models.ProgressComment, 'title' | 'body'>,
	onUploadProgress: models.ProgressChange
) {
	const endpoint: string = '/report/progress-comment/' + projectId;
	return httpService.post(endpoint, data, { onUploadProgress });
}

function createInspectionType(data: CreateInspectionTypePayload, onUploadProgress: models.ProgressChange) {
	return httpService.post('/inspection', data, { onUploadProgress });
}

function createProject(data: any, onUploadProgress: models.ProgressChange) {
	return httpService.post<models.Project>('/project', data, { onUploadProgress });
}

function importProject(data: any, onUploadProgress: models.ProgressChange) {
	return httpService.post<models.Project>('/project/import-project', data, { onUploadProgress });
}

function getAllProjects<T>(config: AxiosRequestConfig) {
	return httpService.get<T>('/project', config).then((response) => response.data);
}

function getArchivedProjects<T>() {
	return httpService.get<{ data: { totalArchivedProjects: number; archivedProjects: T[] } }>('/archive/');
}

function getOrganizationProjects<T>(config: AxiosRequestConfig) {
	let endpoint: string = '/project/customer/projects';

	return httpService.get<T>(endpoint, config).then((response) => response.data);
}

function getOneOrganizationProject(projectId?: string) {
	return httpService.get(`/project/customer/${projectId}`).then((response) => response.data);
}

function getProjectDetails(projectId: string) {
	return httpService.get('/project/' + projectId).then(response => response.data);
}

function getProjectReportLogs<T>(projectId: string, limit: number) {
	return httpService.get<T>(`${constants.CACHE_LOGS_ENDPOINT}?projectId=${projectId}&limit=${limit}`);
}

function getInspectionTypes() {
	return httpService.get<models.InspectionType[]>('/inspection');
}

function reviewReport(data: any, onUploadProgress: models.ProgressChange) {
	return httpService.post('/posts', data, { onUploadProgress });
}

function splitProject({ projectId, data, action }: SplitProjectPayload) {
	return httpService.post('/project/split/' + projectId, { data, action });
}

function updateReport(id: string, data: any, onUploadProgress: models.ProgressChange) {
	return httpService.put<models.Project>('/project/' + id, data, { onUploadProgress });
}

export {
	archiveProject,
	activateProject,
	addProgressComment,
	createProject,
	createInspectionType,
	getAllProjects,
	getArchivedProjects,
	getInspectionTypes,
	getOrganizationProjects,
	getOneOrganizationProject,
	getProjectDetails,
	getProjectReportLogs,
	importProject,
	reviewReport,
	splitProject,
	updateReport,
};
